import type { SaleAssetBusEntity, SaleAssetBusListingItem } from '~/apiClient';
import { NO_VALUE_PLACEHOLDER } from '~/constants/sale';

type RegistrableAsset = Pick<SaleAssetBusEntity | SaleAssetBusListingItem, 'firstRegistration' | 'isToBeRegistered'>;

export type UseAssetRegistrationReturnType = {
    formatFirstRegistration: (asset: RegistrableAsset) => string;
    formatFirstRegistrationCompact: (asset: RegistrableAsset) => string;
    formatFirstRegistrationYear: (asset: RegistrableAsset) => string;
};

export const useAssetRegistration = (): UseAssetRegistrationReturnType => {
    const { tt, td } = useTypedI18n();

    const formatRegistrationDate = (asset: RegistrableAsset): string | undefined =>
        asset.isToBeRegistered || !asset.firstRegistration ? undefined : td(asset.firstRegistration, 'mmyyyyUTC');

    const formatFirstRegistration = (asset: RegistrableAsset): string => formatRegistrationDate(asset) ?? tt('asset.toBeRegistered');

    const formatFirstRegistrationCompact = (asset: RegistrableAsset): string => formatRegistrationDate(asset) ?? NO_VALUE_PLACEHOLDER;

    // The seo copy reads "used {year}", so it wants the bare year and not the month the ui shows next to it
    const formatFirstRegistrationYear = (asset: RegistrableAsset): string =>
        asset.isToBeRegistered || !asset.firstRegistration ? tt('asset.toBeRegistered') : `${new Date(asset.firstRegistration).getUTCFullYear()}`;

    return { formatFirstRegistration, formatFirstRegistrationCompact, formatFirstRegistrationYear };
};
